import React, { Component } from 'react'

class Modal extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.show !== this.props.show || nextProps.children !== this.props.children
    )
  }

  render() {
    return (
      <>
        <div
          className={`modal_backdrop ${this.props.show ? 'modal_open' : ''}`}
          onClick={this.props.clicked}
        ></div>
        <div
          className={`modal_content ${this.props.show ? 'modal_open' : ''}`}
          onClick={this.props.clicked}
        >
          {this.props.children}
        </div>
      </>
    )
  }
}

export default Modal
